import { Stack } from "@mui/material";

export const ScrollButton = ({ onClick, categoryRef, step, children }) => {
  return (
    <Stack
      height="45px"
      width="30px"
      justifyContent="center"
      alignItems="center"
      onClick={() => onClick(categoryRef.current, 50, 100, step)}
      sx={{
        ":hover": {
          cursor: "pointer",
          backgroundColor: "rgba(55, 65, 81, 0.04)",
        },
      }}
    >
      {children}
    </Stack>
  );
};
